import { ZipCodeStore } from '@common/stores';
import { ContextWrapper } from './ContextWrapper';

export const ZipCodeStoreContextWrapper = new ContextWrapper<ZipCodeStore>();
